import { render, staticRenderFns } from "./manage-alternateemail-step2.vue?vue&type=template&id=db37ac86&scoped=true&"
import script from "./manage-alternateemail-step2.vue?vue&type=script&lang=tsx&"
export * from "./manage-alternateemail-step2.vue?vue&type=script&lang=tsx&"
import style0 from "./manage-alternateemail-step2.vue?vue&type=style&index=0&id=db37ac86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37ac86",
  null
  
)

export default component.exports